import React from 'react';
import { EDIT_TAG_MANAGER } from 'shared/constants/permissions';
import EmbedMatomo from 'containers/Results/WebsiteResults/EmbedMatomo';

const TagManager = () => <EmbedMatomo permission={EDIT_TAG_MANAGER} urlParams={{ module: 'TagManager', action: 'manageContainers' }} />;

export default TagManager;
